<h1>Facilities</h1>
<div class="card-container">
  <a class="card" routerLink="/facilities/tracking" routerLinkActive="active" (click)="goToPage('tracking')">
    <img src="assets/icons/map.png" alt="Tracking">

    <span>Bus Tracking</span>
  </a>

  <a class="card" routerLink="/facilities/employeeDetails" routerLinkActive="active" (click)="goToPage('employeeDetails')">
      <img src="assets/icons/employee.png" alt="Employee details">

    <span>Employee Details</span>
  </a>

  <a class="card" routerLink="/facilities/schedule" routerLinkActive="active" (click)="goToPage('schedule')">
    <img src="assets/icons/schedule.png" alt="schedule">

    <span>Bus Timings</span>
  </a>

  <a class="card" routerLink="/facilities/fareUpdate" routerLinkActive="active" (click)="goToPage('fareUpdate')">
    <img src="assets/icons/pay.png" alt="Fare update">

    <span>Fare update</span>
  </a>

  <a class="card" routerLink="/facilities/customerSupport" routerLinkActive="active" (click)="goToPage('customerSupport')">
    <img src="assets/icons/customer-service.png" alt="Customer service">

    <span>Customer Support</span>
  </a>

</div>
